module.exports = __webpack_public_path__ + "static/media/male.ddeb31c5.png";